import { Link } from 'react-router';
import { addDays } from '@tahi/core';
import { Money, ScreenHeader } from '../../../ui';
import { spokenPeso } from '../../../ui/spokenPeso';
import { copy, leftText } from '../copy';
import { fundStatusesOf } from '../derive';
import { periodLabel, spokenDate } from '../format';
import { useBudgetToday } from '../hooks';
import { ACCENT_LINK, CARD, FOCUS, LABEL, SCREEN } from '../styles';

const BACK = { to: '/m/budget', label: copy.moduleName };

export function FundsScreen() {
  const s = useBudgetToday();
  if (!s) {
    return (
      <main className={SCREEN}>
        <ScreenHeader title={copy.funds} back={BACK} />
        <p className="text-muted">{copy.loading}</p>
      </main>
    );
  }
  const statuses = fundStatusesOf(s);
  return (
    <main className={SCREEN}>
      <ScreenHeader
        title={copy.funds}
        back={BACK}
        actions={
          <Link to="/m/budget/funds/new" className={ACCENT_LINK}>
            {copy.addFund}
          </Link>
        }
      />
      {statuses.length === 0 ? (
        <p className="text-muted">{copy.noFunds}</p>
      ) : (
        <ul aria-label={copy.funds} className="flex flex-col gap-2.5">
          {statuses.map((st) => {
            const next = addDays(st.range.end, 1);
            return (
              <li key={st.fund.id}>
                <Link
                  to={`/m/budget/funds/${st.fund.id}`}
                  aria-label={copy.fundCard(
                    st.fund.name,
                    spokenPeso(st.leftMinor),
                    spokenDate(next),
                  )}
                  className={`${CARD} flex flex-col gap-1 ${FOCUS}`}
                >
                  <span className="flex items-center justify-between gap-2">
                    <span className="font-medium text-fg">{st.fund.name}</span>
                    {st.fund.id === s.settings.defaultFundId ? (
                      <span className={LABEL}>{copy.defaultBadge}</span>
                    ) : null}
                  </span>
                  <span className="flex items-baseline gap-2">
                    <Money minor={Math.abs(st.leftMinor)} cents="auto" className="text-[26px]" />
                    <span className="text-sm text-muted">{leftText(st.leftMinor, next)}</span>
                  </span>
                  <span className="text-sm text-muted">
                    {periodLabel(st.fund.period)} ·{' '}
                    {copy.spentOf(st.spentMinor, st.fund.amountMinor)}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </main>
  );
}
